import { render, staticRenderFns } from "./ProdutoConsumo.vue?vue&type=template&id=488d1b62&scoped=true"
import script from "./ProdutoConsumo.vue?vue&type=script&lang=js"
export * from "./ProdutoConsumo.vue?vue&type=script&lang=js"
import style0 from "./ProdutoConsumo.vue?vue&type=style&index=0&id=488d1b62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488d1b62",
  null
  
)

export default component.exports